export const legacyDirectEvidencesTypes = {
  mine_erw_accidents: 'Нещасні випадки з мінами/ВЗВ / Mine/ERW related accident',
  explosions: 'Вибухи побачені/почуті / Explosions',
  mines_direct_report: 'Прямий звіт про мінування / Direct report about mines',
  visible_mine_erw: 'Видимі міни/ВЗВ / Visible Mine/ERW',
  debris: 'Уламки/фрагменти ВЗВ / Debris',
  other: 'Інше / Other',
};

export const directEvidenceV2Types = {
  eo: 'Вибухонебезпечні предмети / Explosive Ordnance',
  ground_signs: 'Ознаки на місцевості / Ground signs',
  damage_vehicles_equipment:
    'Пошкодження транспортних засобів і обладнання / Damage on vehicles and equipment',
  indications_sensors:
    'Ознаки, отримані за допомогою датчиків / Indications obtained through sensors',
  media: 'ЗМІ / Media',
  military_documents: 'Військова документація / Military documents',
  testimonies: 'Свідчення / Testimonies',
};

export const directEvidencesTypes = {
  ...legacyDirectEvidencesTypes,
  ...directEvidenceV2Types,
};

export const DIRECT_EVIDENCE_LEGACY_OPTIONS = [
  { value: 'mine_erw_accidents', label: 'Нещасні випадки з мінами/ВЗВ / Mine/ERW related accident' },
  { value: 'explosions', label: 'Вибухи побачені/почуті / Explosions' },
  { value: 'mines_direct_report', label: 'Прямий звіт про мінування / Direct report about mines' },
  { value: 'visible_mine_erw', label: 'Видимі міни/ВЗВ / Visible Mine/ERW' },
  { value: 'debris', label: 'Уламки/фрагменти ВЗВ / Debris' },
  { value: 'other', label: 'Інше / Other' },
];

export const DIRECT_EVIDENCE_V2_OPTIONS = [
  { value: 'eo', label: 'Вибухонебезпечні предмети / Explosive Ordnance' },
  { value: 'ground_signs', label: 'Ознаки на місцевості / Ground signs' },
  {
    value: 'damage_vehicles_equipment',
    label: 'Пошкодження транспортних засобів і обладнання / Damage on vehicles and equipment',
  },
  {
    value: 'indications_sensors',
    label: 'Ознаки, отримані за допомогою датчиків / Indications obtained through sensors',
  },
  { value: 'media', label: 'ЗМІ / Media' },
  { value: 'military_documents', label: 'Військова документація / Military documents' },
  { value: 'testimonies', label: 'Свідчення / Testimonies' },
];

export const legacyIndirectEvidencesTypes = {
  former_military_position_checkpoint:
    'Колишня військова позиція/блокпост / Former military position/checkpoint',
  indirect_mines_report: 'Непрямий звіт про мінування / Indirect report about mines',
  mine_signs: 'Попереджувальні знаки про мінну небезпеку/загородження / Mine signs',
  previous_military_demine_reports:
    'Попередні звіти з розмінування військовими / Previous military demine reports',
  other: 'Інше / Other',
};

export const indirectEvidenceV2Types = {
  military_position: 'Військові позиції / Military position',
  ground_signs: 'Ознаки на місцевості / Ground signs',
  damage_vehicles_equipment:
    'Пошкодження транспортних засобів і обладнання / Damage on vehicles and equipment',
  use_land: 'Використання території / Use of land',
  indications_sensors:
    'Ознаки, отримані за допомогою датчиків / Indications obtained through sensors',
  media: 'ЗМІ / Media',
  military_documents: 'Військова документація / Military documents',
  testimonies: 'Свідчення / Testimonies',
};

export const indirectEvidencesTypes = {
  ...legacyIndirectEvidencesTypes,
  ...indirectEvidenceV2Types,
};

export const INDIRECT_EVIDENCE_LEGACY_OPTIONS = [
  { value: 'former_military_position_checkpoint', label: 'Колишня військова позиція/блокпост / Former military position/checkpoint' },
  { value: 'indirect_mines_report', label: 'Непрямий звіт про мінування / Indirect report about mines' },
  { value: 'mine_signs', label: 'Попереджувальні знаки про мінну небезпеку/загородження / Mine signs' },
  { value: 'previous_military_demine_reports', label: 'Попередні звіти з розмінування військовими' },
  { value: 'other', label: 'Інше' },
];

export const INDIRECT_EVIDENCE_V2_OPTIONS = [
  { value: 'military_position', label: 'Військові позиції / Military position' },
  { value: 'ground_signs', label: 'Ознаки на місцевості / Ground signs' },
  {
    value: 'damage_vehicles_equipment',
    label: 'Пошкодження транспортних засобів і обладнання / Damage on vehicles and equipment',
  },
  { value: 'use_land', label: 'Використання території / Use of land' },
  {
    value: 'indications_sensors',
    label: 'Ознаки, отримані за допомогою датчиків / Indications obtained through sensors',
  },
  { value: 'media', label: 'ЗМІ / Media' },
  { value: 'military_documents', label: 'Військова документація / Military documents' },
  { value: 'testimonies', label: 'Свідчення / Testimonies' },
];

export const engEvidencesType = {
  mine_erw_accidents: 'Mine/ERW related accident',
  explosions: 'Explosions',
  mines_direct_report: 'Direct report about mines',
  visible_mine_erw: 'Visible Mine/ERW',
  debris: 'Debris',
  other: 'Other',
  eo: 'Explosive Ordnance',
  ground_signs: 'Ground signs',
  damage_vehicles_equipment: 'Damage on vehicles and equipment',
  indications_sensors: 'Indications obtained through sensors',
  media: 'Media',
  military_documents: 'Military documents',
  testimonies: 'Testimonies',
  former_military_position_checkpoint: 'Former military position/checkpoint',
  indirect_mines_report: 'Indirect report about mines',
  mine_signs: 'Mine signs',
  previous_military_demine_reports: 'Previous military demine reports',
  military_position: 'Military position',
  use_land: 'Use of land',
};
